import Loader from 'react-loaders'
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const longitude = parseFloat(process.env.REACT_APP_LONGITUDE)
  const latitude = parseFloat(process.env.REACT_APP_LATITUDE)
  const contactArray = ['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']
  const refForm = useRef()
  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        () => {
          alert('Message sent successfully!')
          window.location.reload()
        },
        () => {
          alert('Message failed to send. Please try again!')
        }
      )
      .catch((err) => console.log(err))
  }
  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              strArray={contactArray}
              idx={15}
              letterClass={letterClass}
            />
          </h1>
          <p>
            I am available for work. Don't hesitate to contact me using below
            form
          </p>
          <div className="contact-form">
            <form ref={refForm} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input type="text" name="name" placeholder="Name" required />
                </li>
                <li className="half">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </li>
                <li>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    name="message"
                    placeholder="Message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Long Pham Thien <br />
          Ho Chi Minh City, Vietnam <br />
          Le Thuc Hoach Street <br />
          Tan Phu District <br />
          <span>longphamthien.work@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer center={[longitude, latitude]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[longitude, latitude]}>
              <Popup>I'm here !!!</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" active={true} />
    </>
  )
}

export default Contact
